module.exports = __webpack_public_path__ + "media/images/home/c3logo_oct24_eologo_nyc_white-5625896de6b5dd181836d1efc44c5e58.png";